export class SignFrame {
  label: string;
  value: number;

  constructor(label: string, value: number) {
    this.label = label;
    this.value = value;
  }
}

export const SignFramesChoices = {
  WOOD: new SignFrame('Hout', 0),
  ALUMINIUM: new SignFrame('Aluminium', 1)
};

export const SignFramesChoiceArray = Object.values(SignFramesChoices);
